import React from 'react'
import TieredPlans from './TieredPlans'
import RobotBundle from './RobotBundle'
import { ContentfulEntry, CurrencyExchangeRate } from '../Page'
import CellDataPlan from './CellDataPlan'

interface Props {
  contentfulEntry: ContentfulEntry
  currencyExchangeRate: CurrencyExchangeRate
  displayCellDataPlan: boolean
}

const Subscriptions: React.FC<Props> = ({
  contentfulEntry,
  currencyExchangeRate,
  displayCellDataPlan
}) => {
  return (
    <div className='subscriptions-pricing__subscriptions'>
      <TieredPlans contentfulEntry={contentfulEntry} currencyExchangeRate={currencyExchangeRate} />
      <hr className='subscriptions-pricing__rule' />
      {displayCellDataPlan ? (
        <CellDataPlan />
        ) : (
        <RobotBundle contentfulEntry={contentfulEntry} currencyExchangeRate={currencyExchangeRate} />
      )}
    </div>
  )
}

export default Subscriptions
